import React, { CSSProperties } from "react";
import { IELabelState } from "./Interfaces";
import { TextEl } from "./index";
import * as Helpers from "./base/Helpers";

class ELabel extends TextEl<HTMLSpanElement, IELabelState> {
    _elRef: React.RefObject<HTMLAnchorElement> = React.createRef();

    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
        };

        if (this.props.Brand) {
            const { Brand } = this.props;

            styles = {
                backgroundColor: "transparent",
                color: Brand.fontColor,
                fontFamily: Brand.fontFamily,
                textDecoration: "none",
                lineHeight: this.__unitSize(
                    Helpers.getLineHeightFromFontSize(Brand.documentFontSize)
                ),
                textAlign: "left",
                verticalAlign: "baseline",
                fontSize: this.__unitSize(Brand.documentFontSize),
            };
        }

        if (this.props.size) {
            styles.fontSize = this.__unitSize(this.props.size);
            styles.lineHeight = this.__unitSize(
                Helpers.getLineHeightFromFontSize(this.props.size)
            );
        }

        if (this.props.color) {
            styles.color = this.props.color;
        }
        return styles;
    };

    getBreak = () => {
        if (this.props.break) {
            return <br />;
        }
    };

    getFontColor() {
        if (this.props.color) {
            return this.props.color;
        }
        if (this.props.Brand) {
            return this.props.Brand.fontColor;
        }

        return "#2c2c2c";
    }

    componentDidMount() {
        const el = this._elRef.current;

        if (el) {
            el.style.setProperty("text-decoration", "none", "important");
            el.style.setProperty("color", this.getFontColor(), "important");
        }
    }

    render(): JSX.Element {
        const { Brand, style, ...rest } = this.props;
        const styles = this.__setStyle(this.getStyles());
        return (
            <React.Fragment>
                <span ref={this._elRef} border="0" style={styles} {...rest}>
                    {this.props.children}
                </span>
                {this.getBreak()}
            </React.Fragment>
        );
    }
}

export { ELabel };
